import { Routes } from '@angular/router';
import { roleGuard, rootSystemAdminGuard } from '../../../lib/guards/admin-role.guard';
import { AI_PROVIDER_CONFIG_CONFIG } from './base/ai-provider-config-config';

export const aiProviderConfigRoutes: Routes = [
  {
    path: AI_PROVIDER_CONFIG_CONFIG.routePath,
    data: { title: 'AI Provider 설정' },
    canActivate: [roleGuard('ADMIN_MASTER'), rootSystemAdminGuard],
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
      },
      {
        path: 'list',
        loadComponent: () =>
          import(
            './components/smart/ai-provider-config-list-page/ai-provider-config-list-page.component'
          ).then((m) => m.AiProviderConfigListPageComponent),
        children: [
          {
            path: ':id',
            loadComponent: () =>
              import(
                './components/smart/ai-provider-config-detail-page/ai-provider-config-detail-page.component'
              ).then((m) => m.AiProviderConfigDetailPageComponent),
            data: { title: 'AI Provider 상세' },
          },
        ],
      },
    ],
  },
];
